
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogDescription,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { DonationContent } from "./DonationContent";
import { DonationHeader } from "./DonationHeader";
import { DonationButton } from "./DonationButton";
import { LucideIcon } from "lucide-react";

interface DonationDetailsDialogProps {
  title: string;
  description: string;
  fullDescription: string;
  price: number;
  priceId: string;
  icon: LucideIcon;
  name: string;
}

export function DonationDetailsDialog({
  title,
  description,
  fullDescription,
  price,
  priceId,
  icon,
  name
}: DonationDetailsDialogProps) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button 
          variant="link" 
          className="text-purple-600 hover:text-purple-700 text-xs md:text-sm"
          aria-label={`Learn more about ${name}`}
        >
          Learn More
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-4xl h-[90vh] md:h-auto md:max-h-[80vh] flex flex-col bg-app-surface border-app-border">
        <DialogTitle className="text-lg md:text-xl text-app-text-primary">{title}</DialogTitle>
        <DialogDescription className="text-app-text-secondary">Support our ministry with a donation</DialogDescription>
        <div className="py-4 flex-1 overflow-y-auto">
          <DonationHeader icon={icon} title={title} />
          <div className="bg-app-surface-elevated rounded-lg p-4 md:p-6 mb-6 border border-app-border">
            <DonationContent content={fullDescription} />
          </div>
        </div>
        <div className="flex justify-between items-center mt-4 pt-4 border-t border-app-border sticky bottom-0 bg-app-surface">
          <span className="text-lg md:text-xl font-bold text-app-text-primary">
            ${price.toFixed(2)}
          </span>
          <DonationButton 
            priceId={priceId}
            price={price}
            variant="default"
            size="default"
            isCompact={false}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
